import { render } from "./PdfLearningViewer.vue?vue&type=template&id=192304ca&scoped=true"
import script from "./PdfLearningViewer.vue?vue&type=script&lang=js"
export * from "./PdfLearningViewer.vue?vue&type=script&lang=js"

import "./PdfLearningViewer.vue?vue&type=style&index=0&id=192304ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192304ca"]])

export default __exports__